import { TLoginStep } from '../types/TLoginStep';

export const getLoginButtonLabel = (loginStep: TLoginStep, isCheckingDomain: boolean, isRedirectingToSso: boolean) => {
  if (isRedirectingToSso) {
    return 'Redirecting to company login…';
  }

  if (isCheckingDomain) {
    return 'Checking sign-in method…';
  }

  if (loginStep === 'SSO_LOGIN') {
    return 'Login via company login';
  }

  if (loginStep === 'PASSWORD_LOGIN') {
    return 'Sign In';
  }

  return 'Continue';
};
